export enum FilterTypes {
  SELLER = "seller",
  DATE_RANGE = "dateRange",
  SEARCH = "search",
  MULTI_SEARCH = "multiSearch",
  MULTI_SEARCH_NEW = "multiSearch-new",
  MULTI_SEARCH_OR_NAME = "multiSearchOrName",
  SERVICE_PICKUP="service-pickup",
  SERVICE_PARCELS="service-parcels",
  SERVICE_RETURNS="service-returns",
  SERVICE_PROBLEMATIC="service-problematic",
  MULTI_SELECT = "multiSelect",
  PARCEL_STATUS = "parcelStatus",
  DISPOSED_BY = "disposedBy",
  STATUS = "status",
  STATE = "state",
  MARKETPLACE = "marketplace",
  MARKETPLACE_FILTERED = "marketplaceFilterd",
}

export type ValueType = null | Date;

export interface IDateRangeInputProps {
  customClass?: string;
  customDateFormat?: string;
  onChange: (dates: ValueType[]) => void;
  placeholder?: string;
  showTabs: boolean;
  value: ValueType[];
}
